export default "__VITE_ASSET__e31e82b9__"